<template>
  <!-- No body: dentro do .app-main (z-index próprio) a janela ficava por
       baixo da barra lateral, que cobria o lado esquerdo dela -->
  <Teleport to="body">
    <div class="modal-overlay" @click.self="onClickFora">
      <div
        class="app-modal"
        :class="`app-modal--${tamanho}`"
        role="dialog"
        aria-modal="true"
        :aria-label="titulo"
      >
        <header class="app-modal__cabecalho">
          <h2 class="app-modal__titulo">{{ titulo }}</h2>
          <button
            type="button"
            class="app-modal__fechar"
            title="Fechar"
            @click="$emit('fechar')"
          >
            <AppIcon
              name="fechar"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              width="18"
              height="18"
            />
          </button>
        </header>

        <component
          :is="formulario ? 'form' : 'div'"
          class="app-modal__conteudo"
          @submit.prevent="$emit('enviar')"
        >
          <div class="app-modal__corpo">
            <!-- Erro de salvar: dentro da janela (fora dela ficava atrás do fundo) -->
            <div v-if="erro" class="msg-error app-modal__erro" role="alert">
              {{ erro }}
            </div>
            <slot />
          </div>
          <footer v-if="$slots.rodape" class="app-modal__rodape">
            <slot name="rodape" />
          </footer>
        </component>
      </div>
    </div>
  </Teleport>
</template>

<script>
// Modal padrão das telas: cabeçalho com título e fechar, corpo (slot) e
// rodapé com os botões (slot "rodape"). Com `formulario`, corpo e rodapé
// ficam dentro de um <form> e o Enter/botão submit emite "enviar".
export default {
  name: "AppModal",
  props: {
    titulo: { type: String, required: true },
    // pequeno 440px | medio 560px | grande 920px
    tamanho: { type: String, default: "medio" },
    formulario: { type: Boolean, default: false },
    // Mantém o comportamento que cada tela já tinha ao clicar no fundo
    fecharAoClicarFora: { type: Boolean, default: true },
    erro: { type: String, default: "" },
  },
  emits: ["fechar", "enviar"],
  mounted() {
    window.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    onClickFora() {
      if (this.fecharAoClicarFora) this.$emit("fechar");
    },
    onKeydown(event) {
      if (event.key === "Escape") this.$emit("fechar");
    },
  },
};
</script>

<style>
/* Sem scoped: o conteúdo dos slots é da tela que usa o modal. */
.app-modal {
  background: var(--c-surface);
  border-radius: var(--r-xl);
  box-shadow: var(--sh-xl);
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: fa-slide-up 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.app-modal--pequeno {
  max-width: 440px;
}

.app-modal--medio {
  max-width: 560px;
}

.app-modal--grande {
  max-width: 920px;
}

.app-modal__cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.125rem 1.5rem;
  border-bottom: 1px solid var(--c-border-light);
}

.app-modal__titulo {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--c-text);
}

.app-modal__fechar {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border: none;
  border-radius: var(--r-sm);
  background: transparent;
  color: var(--c-text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-modal__fechar:hover {
  background: var(--c-bg);
  color: var(--c-text);
}

.app-modal__conteudo {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
}

.app-modal__corpo {
  padding: 1.25rem 1.5rem;
  overflow-y: auto;
}

.app-modal__erro {
  margin-top: 0;
  margin-bottom: 1rem;
}

.app-modal__rodape {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--c-border-light);
}

@media (max-width: 640px) {
  .app-modal {
    max-height: 92vh;
  }

  .app-modal__cabecalho,
  .app-modal__corpo,
  .app-modal__rodape {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .app-modal__rodape {
    flex-direction: column-reverse;
  }

  .app-modal__rodape .btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
